import React, {useEffect} from "react";

import {DetailedHTMLProps} from "react";
import {HTMLAttributes} from "react";
import {Link} from "gatsby";
import {MouseEvent} from "react";

import clsx from "clsx";

import {graphql} from "gatsby";
import {useStaticQuery} from "gatsby";

import {useState} from "react";

import useHandleResize from "@js/hook/useHandleResize";

import Backdrop from "@js/component/Backdrop";
import BarsIcon from "@js/component/icon/BarsIcon";
import ChevronDownIcon from "@js/component/icon/ChevronDownIcon";
import ChevronRightIcon from "@js/component/icon/ChevronRightIcon";
import ChevronUpIcon from "@js/component/icon/ChevronUpIcon";
import Logo from "@js/component/Logo";
import TimesIcon from "@js/component/icon/TimesIcon";
import {Headset} from 'lucide-react';

import {useSelector} from "react-redux";
import StoreState from "@js/store/StoreState";
import * as classNames from "@css/component/TopMenu.module.scss";
import {GatsbyImage, IGatsbyImageData} from "gatsby-plugin-image";
import CustomerServicePopup from '@js/component/CustomerServicePopup';
import { useLocation } from "@reach/router";



/**
 * @type WordpressMenu
 */
type WordpressMenu = {
    menuItems: {
        nodes: {
            id: string;
            label: string;
            parentId: string;
            url: string;
        }[];
    };
};

/**
 * @type FileData
 */
type FileData = {
    file: {
        childImageSharp: {
            gatsbyImageData: IGatsbyImageData;
        };
    };
};

/**
 * @type WordpressMenuData
 */
type WordpressMenuData = {
    wordpressMenu: WordpressMenu;
};

/**
 * @type Data
 */
type Data = WordpressMenuData & FileData;

/**
 * @type TopMenuProps
 */
export type TopMenuProps = Omit<DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>, "children">;

/**
 * @const TopMenu
 */
const TopMenu = (props: TopMenuProps) => {
    const {
        className,
        ...restProps
    } = props;
    const advisorUrl = useSelector((storeState: StoreState) => storeState.information.advisorUrl);
    const hasCompleted = useSelector((storeState: StoreState) => storeState.information.hasCompleted);
    const hasVisited = useSelector((storeState: StoreState) => storeState.information.hasVisited);
    const [activeMenuItems, setActiveMenuItems] = useState<string[]>([]);
    const [onShowAreaBalloon, setOnShowAreaBalloon] = useState(false);

    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const [isBackdropVisible, setIsBackdropVisible] = useState(false);
    const [isNavAllowed, setIsNavAllowed] = useState(true);
    const [activeMobileItems, setActiveMobileItems] = useState<string[]>([]);

    const isMobileView = useHandleResize();

    const location = useLocation();

    useEffect(() => {
        if (typeof window !== "undefined") {
            setIsNavAllowed(!location.pathname.includes("aanvragen/"));
        }
    }, [location.pathname]);

    // useEffect(() => {
    //     if (typeof window == 'object') { // Check if window is defined to avoid SSR issues
    //         const currentPageUrl = window.location.href;
    //         setIsNavAllowed(!currentPageUrl.includes('aanvragen/'))
    //     }
    // }, [window.location.href]);

    const data: Data = useStaticQuery(graphql`
        query {
            wordpressMenu(slug: { eq: "header-menu" }) {
                menuItems {
                    nodes {
                        id
                        label
                        parentId
                        url
                    }
                }
            }
            file(relativePath: { eq: "mobile-menu-image.png" }) {
                childImageSharp {
                    gatsbyImageData(width: 300, quality: 100)
                }
            }
        }
    `);

    const onCloseMenuButtonClick = () => {
        setIsOpen(false);
    };

    const onOpenMenuButtonClick = () => {
        setIsOpen(true);
    };

    const onLinkClick = (
        id: string,
        hasChildren: boolean,
        hasParent: boolean
    ) => (event: MouseEvent) => {

        const shouldToggle = isMobileView && hasChildren && hasParent;

        if (shouldToggle && !activeMobileItems.includes(id)) {
            // 1st tap: open submenu and prevent navigation
            setActiveMobileItems([id]);
            event.preventDefault();
        } else {
            // either desktop, no-children/no-parent, or a 2nd tap on an open item:
            // close everything and allow the link to navigate
            setActiveMobileItems([]);
            setIsOpen(false);
        }

        // remove focus outline from the link/button
        if (document.activeElement instanceof HTMLElement) {
            document.activeElement.blur();
        }
    };

    const onMenuItemMouseOut = (id: string, hasChildren: boolean) => {
        if (hasChildren) {
            setIsBackdropVisible(false);

            setActiveMenuItems([]);
        }
    };

    const onMenuItemMouseOver = (id: string, hasChildren: boolean) => {
        if (hasChildren) {
            setIsBackdropVisible(true);

            setActiveMenuItems([id]);
        }
    };

    const menuItemsNodesLevelOne = data.wordpressMenu.menuItems.nodes.filter((menuItemsNodeLevelOne) => {
        return menuItemsNodeLevelOne.parentId == null;
    });

    const activatedOnPage = () => {
        const currentPageUrl = window.location.href;
        return currentPageUrl.includes('vergelijk') || currentPageUrl.includes('adviseurs/') || currentPageUrl.includes('aanvragen/');
    }

    const onMailTo = () => {
        typeof window == "object" && window.gtag && window.gtag("event", "mailto_click");
    };

    return (
        <>
            <div {...restProps} className={clsx(classNames.topMenu, className)}>
                <div className={classNames.container}>
                    <Link aria-label="Logo" className={classNames.link} to="/">
                        <Logo className={classNames.logo} />
                    </Link>
                    {isOpen && (
                        <button
                            aria-label="Close menu"
                            className={classNames.closeButton}
                            onClick={onCloseMenuButtonClick}
                            type="button"
                        >
                            <TimesIcon className={classNames.icon} />
                        </button>
                    )}
                    {(!(isOpen) && isNavAllowed) && (
                        <button
                            aria-label="Open menu"
                            className={classNames.openButton}
                            onClick={onOpenMenuButtonClick}
                            type="button"
                        >
                            <BarsIcon className={classNames.icon} />
                            <label>Menu</label>
                        </button>
                    )}

                    { (isNavAllowed) && (
                        <nav
                            className={clsx(classNames.navigation, {[classNames.open]: isOpen})}>
                            {menuItemsNodesLevelOne.length >= 1 && (
                                <ul className={classNames.list}>
                                    {menuItemsNodesLevelOne.map((menuItemsNodeLevelOne, index) => {
                                        const menuItemsNodesLevelTwo = data.wordpressMenu.menuItems.nodes.filter(
                                            (menuItemsNodeLevelTwo) => {
                                                return menuItemsNodeLevelTwo.parentId == menuItemsNodeLevelOne.id;
                                            }
                                        );

                                        return (
                                            <li
                                                className={classNames.listItem}
                                                key={menuItemsNodeLevelOne.id}
                                                onMouseLeave={() => {
                                                    onMenuItemMouseOut(
                                                        menuItemsNodeLevelOne.id,
                                                        menuItemsNodesLevelTwo.length >= 1
                                                    );

                                                    index === 0 && (hasVisited || !hasCompleted && advisorUrl) && setOnShowAreaBalloon(false);
                                                }
                                                }
                                                onMouseEnter={() => {
                                                    onMenuItemMouseOver(
                                                        menuItemsNodeLevelOne.id,
                                                        menuItemsNodesLevelTwo.length >= 1
                                                    );

                                                    !activatedOnPage() && index === 0 && (hasVisited || !hasCompleted && advisorUrl) && setOnShowAreaBalloon(true);
                                                }
                                                }
                                            >
                                                <Link
                                                    activeClassName={classNames.active}
                                                    className={clsx(classNames.link, {[classNames.listButton]: index === 0})}
                                                    onClick={
                                                        onLinkClick(
                                                            menuItemsNodeLevelOne.id,

                                                            menuItemsNodesLevelTwo.length >= 1,
                                                        false
                                                        )
                                                    }
                                                    to={menuItemsNodeLevelOne.url}
                                                >

                                                    {menuItemsNodeLevelOne.label}
                                                </Link>

                                                {menuItemsNodesLevelTwo.length >= 1 && (
                                                    <>
                                                        {activeMenuItems.includes(menuItemsNodeLevelOne.id) &&
                                                            <ChevronUpIcon
                                                                className={classNames.icon} />
                                                        }
                                                        {!(activeMenuItems.includes(menuItemsNodeLevelOne.id)) &&
                                                            <ChevronDownIcon
                                                                className={classNames.icon} />
                                                        }
                                                        <section
                                                            className={clsx(classNames.subMenu, {
                                                                [classNames.open]: activeMenuItems.includes(
                                                                    menuItemsNodeLevelOne.id
                                                                ) || activeMobileItems.includes(
                                                                    menuItemsNodeLevelOne.id
                                                                )
                                                            })}>
                                                            <div
                                                                className={classNames.container}>
                                                                <ul className={classNames.list}>
                                                                    {menuItemsNodesLevelTwo.map(menuItemsNodeLevelTwo => {
                                                                        const menuItemsNodesLevelThree = data.wordpressMenu.menuItems.nodes.filter(
                                                                            menuItemsNodeLevelThree => menuItemsNodeLevelThree.parentId === menuItemsNodeLevelTwo.id
                                                                        );

                                                                        return (
                                                                            <li className={classNames.listItem} key={menuItemsNodeLevelTwo.id}>
                                                                                <Link
                                                                                    activeClassName={classNames.active}
                                                                                    className={classNames.link}
                                                                                    onClick={onLinkClick(menuItemsNodeLevelTwo.id,  menuItemsNodesLevelThree.length >=1, true )}
                                                                                    to={menuItemsNodeLevelTwo.url}
                                                                                >
                                                                                    {menuItemsNodeLevelTwo.label}
                                                                                    {menuItemsNodesLevelThree.length > 0 && !isMobileView && (
                                                                                        <ChevronRightIcon className={classNames.icon}/>
                                                                                    )}

                                                                                    {isMobileView && menuItemsNodesLevelThree.length > 0 && (
                                                                                        <ChevronRightIcon className={classNames.icon} />
                                                                                    )}
                                                                                </Link>


                                                                                {menuItemsNodesLevelThree.length >= 1 && (
                                                                                    <ul className={classNames.subMenuList}>
                                                                                        {menuItemsNodesLevelThree.map(menuItemsNodeLevelThree => (
                                                                                            <li className={classNames.listItem} key={menuItemsNodeLevelThree.id}>
                                                                                                <Link
                                                                                                    activeClassName={classNames.active}
                                                                                                    className={classNames.link}
                                                                                                    onClick={onLinkClick(menuItemsNodeLevelThree.id, false, true)}
                                                                                                    to={menuItemsNodeLevelThree.url}
                                                                                                >
                                                                                                    {menuItemsNodeLevelThree.label}
                                                                                                </Link>
                                                                                            </li>
                                                                                        ))}
                                                                                    </ul>
                                                                                )}
                                                                            </li>
                                                                        );
                                                                    })}
                                                                </ul>
                                                            </div>
                                                        </section>
                                                    </>
                                                )}
                                            </li>
                                    );
                                })}

                                { (isMobileView && isOpen) && (
                                    <li className={classNames.listItem} >
                                        <button className={clsx({
                                            [classNames.customerServiceButton]: !isMobileView, // Default styling for desktop
                                            [classNames.mobileMenuCustomerServiceButton]: isMobileView && isOpen // Mobile menu-specific styling
                                        })}
                                                onClick={() => setIsPopupOpen(true)}>
                                            <div className={classNames.iconWrapper}>
                                                <Headset size={32}
                                                         className={classNames.icon} />
                                            </div>
                                            <div className={classNames.textContainer}>
                                <span
                                    className={classNames.serviceTitle}>Klantenservice</span>
                                                <span className={classNames.serviceTime}>Ma - Vr: 09:00-17:00</span>
                                            </div>
                                        </button>
                                    </li>
                                        )}

                                    <li className={classNames.listItem}>
                                        <GatsbyImage
                                            alt="menu image"
                                            className={classNames.image}
                                            image={data.file.childImageSharp.gatsbyImageData}
                                        />
                                    </li>
                                </ul>)}
                        {(isOpen) && (
                            <div className={classNames.extraSpace}/>
                            )}
                        </nav>
                    )}

                    {/*Customer Service Button @ Top right of the home page*/}
                    { (!isMobileView ) && (
                        <button className={clsx({
                            [classNames.customerServiceButton]: !isMobileView, // Default styling for desktop
                            [classNames.mobileMenuCustomerServiceButton]: isMobileView && isOpen // Mobile menu-specific styling
                        })}
                             onClick={() => setIsPopupOpen(true)}>
                            <div className={classNames.iconWrapper}>
                                <Headset size={32}
                                         className={classNames.icon} />
                            </div>
                            <div className={classNames.textContainer}>
                                <span
                                    className={classNames.serviceTitle}>Klantenservice</span>
                                <span className={classNames.serviceTime}>Ma - Vr: 09:00-17:00</span>
                            </div>
                        </button>
                    )}

                    {/*Mobile customer service button, hugs bottom right of the screen */}
                    {(isMobileView && !isOpen) && (
                        <button
                            className={classNames.mobileCustomerServiceButton}
                            onClick={() => setIsPopupOpen(true)}
                        >
                            <div className={classNames.mobileIconWrapper}>
                                <Headset size={28} className={classNames.mobileIcon} />
                            </div>
                        </button>
                    )}
                    <CustomerServicePopup isOpen={isPopupOpen}
                                          onClose={() => setIsPopupOpen(false)} />
                </div>
            </div>
            {typeof window == "object" && isBackdropVisible &&
                <Backdrop className={classNames.backdrop} />}
        </>
    );
};


export default TopMenu;
